module.exports = __webpack_public_path__ + "static/media/community-builder-hero.b148c295.jpg";